import { addHeaderToArray } from "../addHeaderToArray";
import { addAudienceDataToGridElements } from "./addAudienceDataToGridElements";
import { addCreatorInsightsToGridElements } from "./addCreatorInsightsToGridElements";
import { addCreatorsToGridElements } from "./addCreatorsToGridElements";
import { addCustomGridElement } from "./addCustomGridElement";
import { addCampaignDetailsToGridElements } from "./addCampaignDetailsToGridElements";
import { addPostsDataToGridElements } from "./addPostDataToGridElements";
import { addPublicationsToGridElements } from "./addPublicationsToGridElements";
import { addTopPerformingPublicationsToGridElements } from "./addTopPerformingPublicationsToGridElements";
import { addTableSummaryToGridElements } from "./addTableSummaryToGridElements";
import { addTableOfContentsToGridElements } from "./addTableOfContentsToGridElements";
import { addCommentsAnalysisToGridElements } from "./comments-analysis/addCommentsAnalysisToGridElements";
import { addAudienceOverlapToGridElements } from "./audience-overlap/addAudienceOverlapToGridElements";

export const getReportGridElements = async (props) => {
  const {
    contentAutocomplete: contentList,
    dataAggregation,
    formatMessage,
    membersList,
    campaigns,
    savedTemplate,
    templateApplied,
    //
    dispatch,
    setGridElements,
    setHiddenGridElements,
    setShouldRerenderLayout,
    canDisplaySentiments,
    previousGridElements,
    previousHiddenGridElements,
  } = props;

  const newGridElements = [];
  const newHiddenGridElements = [];

  // Title box
  await addCustomGridElement(
    "title-box",
    newGridElements,
    newHiddenGridElements,
    savedTemplate,
    templateApplied,
  );

  // PROJECT OVERVIEW
  await addHeaderToArray(
    formatMessage({
      id: "ws_campaign_overview",
      defaultMessage: "Campaign overview",
    }),
    newGridElements,
    1,
    "campaign-overview",
    savedTemplate,
    templateApplied,
  );

  // ProjectDetails
  addHeaderToArray(
    formatMessage({
      id: "ws_campaign_details",
      defaultMessage: "Campaign details",
    }),
    newGridElements,
    2,
    "metadata",
    savedTemplate,
    templateApplied,
  );
  await addCampaignDetailsToGridElements(
    campaigns,
    newGridElements,
    newHiddenGridElements,
    savedTemplate,
    templateApplied,
  );

  // Creators insights
  await addHeaderToArray(
    formatMessage({
      id: "ws_creator_insights",
      defaultMessage: "Creator insights",
    }),
    newGridElements,
    2,
    "creator-insights",
    savedTemplate,
    templateApplied,
  );
  await addCreatorInsightsToGridElements(
    newGridElements,
    newHiddenGridElements,
    savedTemplate,
    templateApplied,
    campaigns,
    dataAggregation,
  );

  // Creators in the campaign
  addHeaderToArray(
    formatMessage({
      id: "ws_creators_in_the_campaign",
      defaultMessage: "Creators in the campaign",
    }),
    newGridElements,
    2,
    "creator",
    savedTemplate,
    templateApplied,
  );
  await addCreatorsToGridElements(
    dispatch,
    newGridElements,
    newHiddenGridElements,
    savedTemplate,
    templateApplied,
    membersList,
    contentList,
    campaigns,
    dataAggregation,
  );

  // Campaign audience data
  await addHeaderToArray(
    formatMessage({
      id: "ws_campaign_audience_data",
      defaultMessage: "Campaign audience data",
    }),
    newGridElements,
    2,
    "audience-data",
    savedTemplate,
    templateApplied,
  );
  await addAudienceDataToGridElements(
    newGridElements,
    newHiddenGridElements,
    savedTemplate,
    templateApplied,
    campaigns,
    dataAggregation,
  );

  // Audience overlap
  await addHeaderToArray(
    formatMessage({
      id: "ws_audience_overlap",
      defaultMessage: "Audience Overlap",
    }),
    newGridElements,
    2,
    "audience-overlap",
    savedTemplate,
    templateApplied,
  );
  await addAudienceOverlapToGridElements(
    newGridElements,
    newHiddenGridElements,
    savedTemplate,
    templateApplied,
    campaigns,
    dataAggregation,
    formatMessage,
  );

  // PROJECT DATA
  await addHeaderToArray(
    formatMessage({
      id: "ws_campaign_data",
      defaultMessage: "Campaign data",
    }),
    newGridElements,
    1,
    "campaign-data",
    savedTemplate,
    templateApplied,
  );

  // Posts data
  addHeaderToArray(
    formatMessage({
      id: "ws_executive_summary",
      defaultMessage: "Executive summary",
    }),
    newGridElements,
    2,
    "post-data",
    savedTemplate,
    templateApplied,
  );
  await addPostsDataToGridElements(
    newGridElements,
    newHiddenGridElements,
    savedTemplate,
    templateApplied,
    campaigns,
    dataAggregation,
  );

  // CAMPAIGN PERFORMANCE
  addHeaderToArray(
    formatMessage({
      id: "ws_campaign_performance",
      defaultMessage: "Campaign performance",
    }),
    newGridElements,
    1,
    "publication",
    savedTemplate,
    templateApplied,
  );

  await addTopPerformingPublicationsToGridElements(
    formatMessage,
    newGridElements,
    newHiddenGridElements,
    savedTemplate,
    templateApplied,
    campaigns,
    dataAggregation,
  );

  await addPublicationsToGridElements(
    dispatch,
    newGridElements,
    newHiddenGridElements,
    savedTemplate,
    templateApplied,
    membersList,
    contentList,
    formatMessage,
    campaigns,
    dataAggregation,
  );

  // TABLE SUMMARY
  await addHeaderToArray(
    formatMessage({
      id: "ws_summary",
      defaultMessage: "Summary",
    }),
    newGridElements,
    1,
    "table-summary",
    savedTemplate,
    templateApplied,
  );
  await addTableSummaryToGridElements(
    dispatch,
    newGridElements,
    newHiddenGridElements,
    savedTemplate,
    templateApplied,
    formatMessage,
    campaigns,
    dataAggregation,
  );

  // COMMENTS ANALYSIS
  if (canDisplaySentiments) {
    await addHeaderToArray(
      formatMessage({
        id: "ws_comments_analysis",
        defaultMessage: "Comments analysis",
      }),
      newGridElements,
      1,
      "comments-analysis",
      savedTemplate,
      templateApplied,
    );

    addCommentsAnalysisToGridElements(
      newGridElements,
      newHiddenGridElements,
      savedTemplate,
      templateApplied,
      campaigns,
      dataAggregation,
      formatMessage,
    );
  }

  // SUMMARY & LEARNINGS
  await addHeaderToArray(
    formatMessage({
      id: "ws_summary_learnings",
      defaultMessage: "Summary & Learnings",
    }),
    newGridElements,
    1,
    "summary-learnings",
    savedTemplate,
    templateApplied,
  );
  addCustomGridElement(
    "summary-learnings",
    newGridElements,
    newHiddenGridElements,
    savedTemplate,
    templateApplied,
  );

  // GLOSSARY
  await addHeaderToArray(
    formatMessage({
      id: "ws_glossary",
      defaultMessage: "Glossary",
    }),
    newGridElements,
    1,
    "glossary",
    savedTemplate,
    templateApplied,
  );
  addCustomGridElement(
    "glossary",
    newGridElements,
    newHiddenGridElements,
    savedTemplate,
    templateApplied,
  );
  addCustomGridElement(
    "glossary-two",
    newGridElements,
    newHiddenGridElements,
    savedTemplate,
    templateApplied,
  );

  await addTableOfContentsToGridElements(newGridElements);

  const getFilteredGridElements = () => {
    const gridElementsBlacklist = [
      "title-box",
      "table-of-contents",
      "header",
      "summary-learnings",
      "glossary",
      "glossary-two",
    ];

    return previousGridElements.filter(
      (item) => !gridElementsBlacklist.includes(item.gridBoxType),
    );
  };

  const entryFilteredGridElements = getFilteredGridElements();

  if (entryFilteredGridElements.length > 0) {
    const additionalHiddenGridElements = [];

    const filteredNewGridElements = newGridElements.filter((item) => {
      const foundElement = previousGridElements.find(
        (el) => el.label === item.label,
      );

      if (!foundElement) {
        additionalHiddenGridElements.push(item);
      }

      return foundElement;
    });

    setGridElements(filteredNewGridElements);
    setHiddenGridElements([
      ...newHiddenGridElements,
      ...additionalHiddenGridElements,
    ]);
  } else {
    setShouldRerenderLayout(true);
    setGridElements(newGridElements);
    setHiddenGridElements(newHiddenGridElements);
  }
};
